<template>
  <stat-card :card-list="list"/>
</template>

<script>
  import StatCard from "@view/components/StatCard"
  export default {
    name: "UserDeviceCount",
    components: {StatCard},
    data() {
      return {
        list: [
          {icon: "el-icon-user-solid", text: "用户总数 / 用户在线数", count: [{val:0},{val:0}], color: "#27A9E3"},
          {icon: "el-icon-user-solid", text: "今日激活用户数", count: 0, color: "#FEBA47"},
          {icon: "el-icon-user-solid", text: "今日删除 / 今日新增用户数", count: [{val:0},{val:0}], color: "#0CCA8E"},
        ]
      }
    },
    created() {
      this.getUserData();
    },
    methods: {
      async getUserData() {
        let res = await this.$Http.getUserCount();
        if (res?.data) {
          this.list[0].count[0].val = +res.data.total || 0;
          this.list[0].count[1].val = +res.data.online || 0;
          this.list[1].count = +res.data.today_active || 0;
          this.list[2].count[0].val = +res.data.today_delete || 0;
          this.list[2].count[1].val = +res.data.today_new || 0;
        }
      },
    }
  }
</script>

<style scoped>

</style>
